
import React from 'react';
import Navbar from './Navbar';
import LeftSidebar from './LeftSidebar';
// Styles imported globally via index.js -> layout.css

export default function MainLayout({ children }) {
    return (
        <div className="app-container">
            <Navbar /> {/* Fixed/Sticky handled in Navbar.module.css */}

            <div className="layout-grid">
                {/* Left Column: Navigation / Profile */}
                <aside className="layout-left">
                    <div className="sticky-top">
                        <LeftSidebar />
                    </div>
                </aside>

                {/* Middle Column: Main Feed Content */}
                <main className="layout-main">
                    {children}
                </main>
            </div>
        </div>
    );
}
